<template>

  <t-page>


    <StepActionDialog @onSubmit="onSubmitStepAction" :type="modalActionType"
                      :production-order-batch-step-id="modalActionStepId"/>

    <b-modal title="Escolha de Fluxo-Processo" id="modal-choice-process-flow" no-close-on-esc no-close-on-backdrop
             @ok="onSubmit" ok-title="Escolher" ok-only>


      <div>

        <h4>Fluxo desejado</h4>

        <t-input radio stacked label="Fluxo-Processo" hide-label :options="processFlowApplicableOptions"
                 v-model="form.processFlowId"/>

      </div>

      <t-msg info>Foram encontrados mais que um fluxo-processo de acordo com o produto informado. Desta forma, será
        necessário selecionar qual o fluxo desejado para ser aplicado a esta Ordem de Fabricação.
      </t-msg>


    </b-modal>

    <!--    <t-page-report

            v-if="form.batchList && form.batchList[0].viewReportId > 0 && command === 'view' && pageFormIsLoaded"
            :go-back-title="t('go-back-list')" :go-back-to="currentPage.name"
            :title="currentPage.singularTitle + ' - #' + form.productionOrderCodeLabel"
            primary-key-column="productionOrderId"
            :primary-key="form.productionOrderId"
            :reportId="form.batchList[0].viewReportId"
        >

          <template #title-buttons="{status}">
            <slot name="title-buttons" :status="status"></slot>
          </template>

        </t-page-report>-->

    <t-page-form :submit-text="'Ordem Fabricação'"
                 :title="'Ordem de Fabricação'"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :submit-external="submitExternal"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">


      <template #title-buttons="{status}">

        <slot name="title-buttons" :status="status"></slot>

        <t-button
            @click="downloadPdf()"
            :sending="downloadPdfFinish"
            enable-loader
            v-if="command !== 'insert' && buttonDownloadPdf !== undefined && buttonDownloadPdf !== null">
          <b-icon-file-earmark-pdf></b-icon-file-earmark-pdf>
          PDF
        </t-button>


        <t-dropdown
            v-if="command !== 'insert' && !StatusProductionOrderType.hasDone(form.statusOrder) && (
                getRenderRule('sub-production-step-enable-return') ||
                getRenderRule('sub-production-step-enable-stop') ||
                relationAccessSubValidation('sub-production-order-reinstall'))"
            variant="outline-primary" icon-settings>

          <template #button-content>
            <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
            Ações
          </template>

          <b-dropdown-item @click="openModalActionStep('return')"
                           v-if="getRenderRule('sub-production-step-enable-return')">Alterar Etapa
          </b-dropdown-item>
          <b-dropdown-item @click="openModalActionStep('stop')"
                           v-if="getRenderRule('sub-production-step-enable-stop')">Parar Produção
          </b-dropdown-item>

          <b-dropdown-item @click="confirmReinstall()"
                           v-if="relationAccessSubValidation('sub-production-order-reinstall')">Atualizar Fluxo
          </b-dropdown-item>

        </t-dropdown>


        <t-button @click="confirmReverse()"
                  outline-danger
                  v-show="(command === 'update' || command === 'view') && StatusProductionOrderType.hasDone(form.statusOrder)"
                  :sending="reverseFinish"
                  enable-loader
                  :title="!relationAccessSubValidation('sub-production-order-reverse-finish') ? 'Perfil de acesso não habilitado para estorno de finalização' : ''"
                  :disabled="!relationAccessSubValidation('sub-production-order-reverse-finish')">
          <b-icon-clipboard-x class="mr-1"></b-icon-clipboard-x>
          Estornar
        </t-button>

      </template>


      <template #default="{status}">

        <b-row>

          <b-col
              :class="{'col-12':command === 'insert','col-lg-9':command !== 'insert','col-md-8':command !== 'insert','col-sm-12':command !== 'insert'}">

            <b-card>

              <t-input v-model="form.productionOrderId" hidden/>

              <slot :status="status">

                <b-card-title v-if="command !== 'insert'">Dados Básicos</b-card-title>

                <slot name="header" :status="status"></slot>

                <div v-if="!disableTypeOrigin">

                  <t-input v-model="form.typeOrigin" :options="typesOrigin" label="Tipo de Origem" radio/>

                  <t-input v-model="form.saleId" v-show="form.typeOrigin === 1" :options="salesOptions" label="Venda"
                           select
                           :required="form.typeOrigin === 1"/>

                </div>

                <t-input-product v-if="!disableProduct" v-model="form.productId" required/>

                <slot name="after-product" :status="status"></slot>

                <t-input v-if="!disableQuantityManually" v-model="form.quantityManually" number label="Quantidade"
                         required/>

                <t-input v-if="!disableDeadline" v-model="form.deadline" label="Prazo de Produção" date required/>

                <b-row>

                  <t-input v-model="form.stockPlaceProductInsideId" :options="groupStockProductLocationOptions" select
                           label="Entrada no Estoque" cols="6" required/>


                  <t-input cols="6" v-if="command === 'insert'" v-model="form.processFlowId" fixed
                           :options="processFlowOptions"
                           select
                           label="Fluxo será aplicado" required/>

                  <t-input cols="6" v-else v-model="form.processFlowId" fixed :options="processFlowOptions"
                           select
                           label="Fluxo aplicado"
                           help="Caso desejar alterar o fluxo-processo será necessário excluir e inserir novamente a OP"
                           required/>

                </b-row>


                <slot name="before-fields" :status="status"></slot>

                <!--ATENÇÃO NÃO ESQUECER DE UTILIZAR template #default="{status} para funcionamento correto-->
                <div v-if="fieldsCustomizable.length > 0">


                  <t-page-form-field-customized
                      ref="fieldsGeneral"
                      :command="command" :status="status" :user-auth="userAuth"
                      :fields-customizable="entityFieldCustomized('page')"
                      :primary-key="form.productId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
                      :primary-key-column="fieldKey" foreign-key-column="pageId"
                  />

                </div>

                <slot name="before-note" :status="status"></slot>

                <t-input class="mb-2" v-model="form.note" small="Utilize este campo apenas para complementar alguma informação relevante. Para registrar não conformidades (off-spec) ou restrições (como tolerâncias diferentes), utilize os campos específicos destinados a esses casos." label="Observações" max-length="500" textarea/>


                <t-form-card title="Ações especiais de inclusão"
                             v-if="command === 'insert' && relationAccessSubValidation('sub-production-order-actions-insert')">

                  <t-input v-model="form.actionInsertType" :options="actionInsertTypeOptions" label="Ação especial"
                           hide-label
                           stacked radio/>

                  <div class="alert alert-warning mt-1" v-if="form.actionInsertType === 2">

                    <b-row>

                      <t-input select
                               v-model="form.goProcessFlowStepId" :options="stepsAll" cols="6" label="Etapa desejada"
                               required/>

                      <t-input select
                               v-model="form.typeStopId" :options="typeProductionReturnOptions" cols="6" label="Motivo"
                               required/>

                    </b-row>


                  </div>

                  <div class="mt-2">
                    <a @click="form.actionInsertType = null" v-if="form.actionInsertType > 0">Limpar Ação Especial</a>
                  </div>

                </t-form-card>

              </slot>

            </b-card>


            <slot name="before-log" :status="status"></slot>

            <b-card class="mt-2" v-if="command !== 'insert' && pageFormIsLoaded">


              <b-card-title>Responsável Cadastro</b-card-title>

              <b-row>

                <t-input cols="6" v-model="form.logControl.createdUser" label="Criado por" fixed/>
                <t-input cols="6" v-model="form.logControl.createdDate" label="Data Criação" fixed datetime/>

              </b-row>

              <b-card-title v-if="form.logControl.updatedUser !== null" class="mt-3">Responsável Última modificação
              </b-card-title>

              <b-row v-if="form.logControl.updatedUser !== null">

                <t-input cols="6" v-model="form.logControl.updatedUser" label="Alterado por" fixed/>
                <t-input cols="6" v-model="form.logControl.updatedDate" label="Data Alterado" fixed datetime/>

              </b-row>

            </b-card>

          </b-col>

          <b-col class="col-lg-3 col-md-4 col-sm-12" v-if="command !== 'insert'">

            <ProductionBatchFlow
                @onGetStepCurrentId="setStepCurrentId"
                :busy="!pageFormIsLoaded"
                origin-order-form
                :current-page="currentPage"
                :enable-change-status-operation="getRenderRule('sub-production-step-change-operation-status')"
                :production-order-batch-id="form.batchList[0].productionOrderBatchId"/>

          </b-col>

        </b-row>


      </template>

      <template #out-of-form>
        <slot name="out-of-form"></slot>
      </template>

    </t-page-form>

    <div>


    </div>


  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormEmbeddableMixin from "@/mixins/page/pageFormEmbeddableMixin";
import http from "@/services/config/http-common";
import StatusProductionOrderType from "@/model/types/modules/production/StatusProductionOrderType";
import ProcessFlowService from "@/services/modules/production/ProcessFlow.service";
import StatusStepType from "@/model/types/modules/production/StatusStepType";
import FlowStepNotSequenceActionType from "@/model/types/modules/production/FlowStepNotSequenceActionType";
import ui from "@/assets/scripts/ui";
import StepActionDialog from "@/views/modules/production/ProductionOrder/components/StepActionDialog";
import StepActionType from "@/model/types/modules/production/StepActionType";
import ProductionOrderService from "@/services/modules/production/ProductionOrder.service";
import ProductionBatchFlow from "@/views/modules/production/ProductionOrder/ProductionBatchFlow";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormEmbeddableMixin],
  components: {ProductionBatchFlow, StepActionDialog},
  name: 'ProductionOrderFormUniqueBatchEmbeddable',

  data() {
    return {
      ui,
      StatusStepType,
      FlowStepNotSequenceActionType,
      StatusProductionOrderType,
      path: "production/order", //Utilizar somente quando fora do padrão
      enableGeneralFields: true,
      fieldKey: "productionOrderId",
      /*FORM DECLARADO NO MIXIM PARA VIR DE FORA COM OS CAMPOS PADRÕES JUNTOS COM OS CUSTOMIZADOS*/
      error: {//Campos que podem receber retorno de erro do backend
        userId: "",
        name: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      processFlowStepItems: [],
      processFlowStepFields: [
        {key: "name", label: "Produto"},
        {key: "deadlineType", label: "Cálculo de Prazo"},
        {key: "deadlineMinutes", label: "Tempo estimado"},
        {key: "note", label: "Obs."},
      ],
      typesOrigin: [{value: 1, text: "Vendas", disabled: true}, {value: 2, text: "Manual"}],
      salesOptions: [],
      groupStockProductLocationOptions: [],
      prioritiesTypeOptions: [
        {text: 'Normal', value: 1},
        {text: 'Crítica', value: 2},
        {text: 'Urgente', value: 3},
      ],
      actionInsertTypeOptions: [
        {value: 1, text: "Finalizar automaticamente com sucesso"},
        /*{ ATENÇÃO OPÇÃO DESABILIDADE POR INCONSISTENCIA, UMA VEZ QUE SOMENTE PODEREMOS ESPECIFICAR QUAL ETAPA DEPOIS DO FLUXO ESTAR DEFINIDO. DESTA FORMA PARA CORREÇÃO. DEVERÁ TER O FORMATO WIZARD, ONDE A ÚLTIMA ETAPA SÃO AÇÕES ESPECIAIS, JÁ COM AS INFORMAÇÕES DENIFICADAS, PODEREMOS ESPECIFICAR QUAL ETAPA DESEJADA
          value: 2,
          text: "Especificar etapa atual inicial"
        }*/],

      typeProductionReturnOptions: [],
      processFlowApplicableOptions: [],
      processFlowOptions: [],
      modalActionType: '',
      modalActionStepId: 0,
      downloadPdfFinish: false,
      reverseFinish: false,
      stepCurrentId: 0,
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    disableTypeOrigin: Boolean,
    disableProduct: Boolean,
    disableQuantityManually: Boolean,
    disableDeadline: Boolean,
    buttonDownloadPdf: Object
  },
  methods: {

    mountedPrepare() {

      this.mountedPrepareEmbeddable()
    },
    async mountedContinued() {

      if (this.isUpdate() && StatusProductionOrderType.hasDone(this.form.statusOrder)) {
        this.command = 'view'
      }

      await this.getRelationList()

      await this.mountedContinuedEmbeddable() //Deixar sempre no final

    },


    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async onSubmit() {

      if (this.command === 'delete') {
        await this.sendingFormDefault()
      } else {

        //Trava para verificação de regras em objetos Embeddable
        if (this.enabledSubmit) {

          if (this.form.processFlowId === 0) {

            await this.setProcessFlowByProductId()

          } else {

            await this.sendingFormDefault()

          }

        } else {
          await this.$emit("beforeSubmit")
        }

      }


    },

    async confirmReverse() {

      ui.msgConfirm(this, 'ESTORNO DA FINALIZAÇÃO', '<span class="text-danger">Tem certeza que deseja realizar o estorno da finalização desta Ordem de Fabricação <b>' + this.form.productionOrderCodeLabel + '</b>?<br /><br />Obs.: Irá retornar para última etapa sequêncial finalizada.</span>', async () => {

        this.reverseFinish = true

        await ProductionOrderService.reverse(this.form.productionOrderId).then(async () => {

          await this.goPath(this.userAuth.currentPage.path, {
            codSuccess: 100,
            returnMessage: 'Ordem de Fabricação ' + this.form.productionOrderCodeLabel + ' foi estornada a finalização com sucesso!'
          })

        }).catch(error => ui.generalResponseError(this, error))

        this.reverseFinish = false

      })

    },

    async setProcessFlowByProductId() {

      //Após validações especificas de clientes, aqui serão feitas as validações comuns a todas as contas

      await ProcessFlowService.findApplicableByProductId(this.form.productId).then(async (list) => {

        if (list == null || list.length === 0) {

          ui.msgError(this, "Nenhum fluxo de processo encontrado para este produto. Preencha todas as informações do produto para uma nova tentativa de encontrar o fluxo correto")

        } else if (list.length === 1) {

          this.form.processFlowId = list[0].value //Primeira opção é padrão

          //Continua, pois foi encontrado apenas 1 fluxo
          await this.sendingFormDefault()

        } else {
          //Deverá escolher
          this.processFlowApplicableOptions = list
          this.form.processFlowId = list[0].value //Primeira opção é padrão

          this.openDialogForm('modal-choice-process-flow')

        }

      }).catch(error => this.responseError(error))

    },

    async getRelationList() {

      await http.list(this.path + "/selectRelationList?processFlowId=" + this.form.processFlowId).then((list) => {
        this.groupStockProductLocationOptions = list.groupStockProductLocationOptions
        this.stepsAll = list.stepsAll
        this.typeProductionReturnOptions = list.typeProductionReturnOptions
        this.processFlowOptions = list.processFlowOptions

        //Enviar somente se for criação
        if (this.isInsert())
          this.$emit("onLastCreated", list.lastCreated)

      }).catch(error => this.responseError(error))
    },


    setStepCurrentId(id) {
      this.stepCurrentId = id
    },

    openModalActionStep(type) {

      if (this.stepCurrentId > 0) {

        this.modalActionType = type
        this.modalActionStepId = this.stepCurrentId
        this.openDialogForm('modal-action-step')

      } else {
        ui.msgError(this, "Desculpe não foi encontrada etapa atual em andamento para realização de ação especial.")
      }

    },

    onSubmitStepAction(action) {

      this.goPath(this.currentPage.path, {
        codSuccess: 100,
        returnMessage: 'Etapa ' + action.text + ' ' + StepActionType.getReturnMessage(action.value) + ' com sucesso!'
      })
    },

    async downloadPdf() {

      this.downloadPdfFinish = true

      setTimeout(async () => {

        await this.downloadReport(this.buttonDownloadPdf.reportId, this.buttonDownloadPdf.primaryKey, this.buttonDownloadPdf.name)

        this.downloadPdfFinish = false

      }, 100)

    },

    async confirmReinstall() {

      await ui.msgConfirm(this, 'Confirmação', "<b>Deseja atualizar o fluxo de processos desta Ordem de Fabricação?</b><br /><br />Utilize esta opção quando atualizar o fluxo e precisar replicar nas ordens em andamento desejadas. Outra forma é utilizando a Ação em Massa, onde é possível realizar este procedimento em várias Ordens de uma só vez.", async () => {

        ProductionOrderService.reinstall(this.form.productionOrderId).then(async () => {

          await this.goPath(this.userAuth.currentPage.path, {
            codSuccess: 100,
            returnMessage: 'Ordem de Fabricação ' + this.form.productionOrderCodeLabel + ' com fluxo atualizado com sucesso!'
          })

        }).catch(error => this.responseErrorGeneral(error))


      })

    }

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },
  watch: {
    /*'form.processFlowId': {
      handler: async function (after,before) {
        if (after !== undefined && after > 0 && after !== before){
          await this.getRelationList()
        }
      },
      deep: true
    }*/
  }

}
</script>